import checkShippingPriceAlgo from "@/app/usecase/checkShippingPriceAlgo";
import checkShippingPrice from "@/app/usecase/checkShippingPrice";
import routeAlgo from "@/app/usecase/routeOrder";
import { isSameSenderRecipientAddress } from "@/pages/shipment/utils/addressValidation";
import "@/app/type/checkPriceAlgo";
import "@/app/type";
import {ORDER_LOCAL_STORAGE_KEY} from "@/app/constant/order";
import { FlagsMinipack } from "@/feature-flags/flags-minipack/index.js";
import { FlagsWoodPacking } from "@/feature-flags/flags-wood-packing/index.js";
import { slimRecipientPackage, dropRecipientFiles, removeAllCiplFiles } from "@/pages/shipment/app/usecase/ciplFilesDb";
import internationalDocumentUseCase from "@/pages/shipment/app/usecase/internationalDocument";
import { FlagsShipmentSeamless } from "@/feature-flags/flags-shipment-seamless/index.js";

/** @type {string[]} */
const filtersPickUpOrigin = [
    "é=e",
    "kota bks=kota bekasi",
    "south tarogong=tarogong kidul",
    "sanankulon=sanan kulon",
    "daerah=",
    "khusus=",
    "ibukota=",
    "ibu kota=",
    "kota=",
    "city=",
    "special=",
    "istimewa=",
    "region=",
    "kabupaten=",
    "kab=",
    "sub-district=",
    "kecamatan=",
    "kec=",
    "regency="
]


const createInitialState = () => ({
    samedayTypeOder: 'PICKUPSAMEDAY',
    sameday: {
        lastCoordinate: {},
        name: "",
        email: "",
        phoneNumber: "",
        phoneCode: "+62",
        service: "pickupSameday",
        subdistrict: [],
        address: "",
        referencePoint: "",
        routeId: null,
        itemQuantity: [
          {
            label: "1",
            value: 1,
          },
        ],
    },
    /**
     * @type PickupSamedayDataOrder
     */
    samedayForm: {
        lastCoordinate: {},
        name: "",
        email: "",
        phoneNumber: "",
        phoneCode: "+62",
        phoneCodeId: 17,
        service: "pickupSameday",
        subdistrict: [],
        pickupAddress: "",
        pickupSubDistrict: "",
        dropoffAddress: "",
        referencePoint: "",
        origin: "",
        dropoffOrigin: "",
        routeId: null,
        itemQuantity: [
          {
            label: "1",
            value: 1,
          },
        ],
    },
    typeOder: 'DROPOFF',
    isLoadingCheckPrice: false,
    isLoadingCheckPricePage: false,
    sender: {
        lastCoordinate: {},
        name: "",
        email: "",
        phoneNumber: "",
        phoneCode: "+62",
        service: "dropoff",
        subdistrict: [],
        address: "",
        referencePoint: "",
        routeId: null
    },
    /**
     * @type SenderDataOrder
     */
    senderForm: {
        lastCoordinate: {},
        name: "",
        email: "",
        phoneNumber: "",
        phoneCode: "+62",
        phoneCodeId: 17,
        service: "",
        subdistrict: [],
        pickupAddress: "",
        pickupSubDistrict: "",
        dropoffAddress: "",
        referencePoint: "",
        origin: "",
        dropoffOrigin: "",
        timeSlotPickup: null,
    },
    recipient: {
        name: "",
        phoneNumber: "",
        phoneCode: "+62",
        benchmark: "",
        address: "",
        addressLabel: "rumah",
        destination: [],
        id: 1,
    },
    recipientChooseProduct: null,
    validateRecipient: {
        name: "",
        phoneNumber: null,
        address: "",
    },
    validatePackage: {
        commodity: null,
        weight: null,
    },
    validateDropShipper: {
        isSelected: false,
        name: "",
        phoneNumber: "",
        isValid: false,
    },
    getDropShipper: {
        name: "",
        phoneNumber: "",
        phoneCode: "+62",
        phoneCodeId: 17,
        isActive: false
    },
    getCIPL: {
        email: "",
        id: "",
        taxId: "",
        file: [],
    },
    ciplFlags: null,
    pickUpOrigin: {
        district: "",
        subDistrict: "",
        routeId: 0,
    },
    samedayPickUpOrigin: {
        district: "",
        subDistrict: "",
        routeId: 0,
    },
    /** @type {PickUpSchedule}*/
    pickUpSchedules: {
        route_id: 0,
        dynamic_pickup_id: 0,
        is_disabled_today: false,
        is_disabled_tomorrow: false,
        sunday: [],
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
    },
    package: {
        commodity: [],
        quantity: [{
            label: '1',
            value: 1,
        }],
        weight: 1,
        length: 0,
        width: 0,
        height: 0,
        value: 0,
        insurance: true,
        fragile: false,
        isWoodPacking: false,
        cod: false,
        dfod: false,
        productType: "",
    },
    errorCheckPrice: null,
    errorBulkyCheckPrice: null,
    /**
     * @type {Recipient[]}
     */
    recipientsPackage: [],
    responseCheckPrice: [],
    isAddNewRecipient: false,
    editIndex: -1,
    listOfErrorsBulkyCheckPrice: [],
    listReceiverProduct: [],
    triggerAddNewRecipient: false,
    isLoadingSamedayPrice: false,
    samedayCheckPriceData: {},
    samedayFormValidation: {},
    isPickupBoost: false,
    pickupBoostValue: 0,
    isPickupError: false,
})

const state = createInitialState()

const SHIPMENT_FORM_STORAGE_KEYS = [
    ORDER_LOCAL_STORAGE_KEY.RECIPIENT,
    ORDER_LOCAL_STORAGE_KEY.RECIPIENT_PACKAGE,
    ORDER_LOCAL_STORAGE_KEY.SENDER,
    ORDER_LOCAL_STORAGE_KEY.SENDER_FORM,
    ORDER_LOCAL_STORAGE_KEY.TYPE_ORDER,
    ORDER_LOCAL_STORAGE_KEY.PICKUP_ORIGIN,
    ORDER_LOCAL_STORAGE_KEY.PACKAGE,
    ORDER_LOCAL_STORAGE_KEY.PAYMENT_DRAFT,
    ORDER_LOCAL_STORAGE_KEY.EDIT_INDEX,
    'selectedDestination',
    'dropshipperPackage',
    'pickupRouteId',
    'origin',
    'dropoffOrigin',
    'isPickupBoost',
    'pickupBoostValue',
    'fromPickupBooster',
]

const actions = {
    setIsPickupError({ commit }, payload) {
        commit('SET_IS_PICKUP_ERROR', payload)
    },
    clearOrderFormStorage() {
        if (typeof localStorage === 'undefined') return

        SHIPMENT_FORM_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key))

        //remove indexedDB
        removeAllCiplFiles()
    },
    resetOrderState({commit}) {
        commit('RESET_ORDER_STATE')
    },
    setPickupBoostValue({ commit }, payload) {
        commit('SET_PICKUP_BOOST_VALUE', payload)
        localStorage.setItem('pickupBoostValue', payload)
    },
    setPickupBoost({ commit }) {
        commit('SET_IS_PICKUP_BOOST', true)
        localStorage.setItem('isPickupBoost', true)
    },
    removePickupBoost({ commit }) {
        commit('SET_IS_PICKUP_BOOST', false)
        localStorage.setItem('isPickupBoost', false)
        commit('SET_PICKUP_BOOST_VALUE', 0)
        localStorage.setItem('pickupBoostValue', 0)
    },
    setCleanRecipientPackage({commit}) {
        const currentState = state.recipientsPackage
        const newState = []
        // reset index recipient
        currentState.forEach((recipient) => {
            if (recipient.destination.length > 0 && recipient.choicePackage) {
                recipient.index = newState.length + 1
                newState.push(recipient)
            }
        })

        newState.push({
            isPackageCOD: false,
            isValidDropshipper: false,
            dropshipperName: "",
            dropshipperPhoneNumber: "",
            index: newState.length + 1,
            name: "",
            phoneNumber: "",
            address: "",
            destination: [],
            referencePoint: "",
            labelPoint: "",
            packageCommodity: "",
            isPackageFreagile: false,
            packageQuantity: 1,
            packageWeight: 1,
            packageWidth: 0,
            packageLength: 0,
            packageHeight: 0,
            packageValue: 0,
            isPackageInsurance: false,
            isPackageDFOD: false
        })
        commit('CLEAN_RECIPIENT_PACKAGE', newState)
    },
    setTypeOrder({commit}, payload) {
        commit('SET_TYPE_ORDER', payload)
        localStorage.setItem('typeOrder', JSON.stringify(payload))
    },
    setSamedayTypeOrder({commit}, payload) {
        commit('SET_SAMEDAY_TYPE_ORDER', payload)
        localStorage.setItem('samedayTypeOrder', JSON.stringify(payload))
    },
    setSender({commit}, payload) {
        commit('SET_SENDER', payload)
        localStorage.setItem('sender', JSON.stringify(payload))
    },
    setSameday({commit}, payload) {
        commit('SET_SAMEDAY', payload)
        localStorage.setItem('sameday', JSON.stringify(payload))
    },
    setSenderForm({commit}, payload) {
        commit('SET_SENDER_FORM', payload)
        localStorage.setItem('senderForm', JSON.stringify(payload))
    },
    setSamedayForm({commit}, payload) {
        commit('SET_SAMEDAY_FORM', payload)
        localStorage.setItem('samedayForm', JSON.stringify(payload))
    },
    setPackage({commit}, payload) {
        commit('SET_PACKAGE', payload)
    },
    // call this to get the origin of the sender
    async setSenderPickUpOrigin({commit, dispatch, state}, payload) {
        if (!payload.lat || !payload.lng) return
        return await routeAlgo.getReverseRoute(payload.lat, payload.lng).then(async res => {
            const payloadPickUpOrigin = {
                district: res.data.district,
                subDistrict: res.data.sub_district,
                routeId: 0,
            }
            for (const filter of filtersPickUpOrigin) {
                let [key, value] = filter.split('=')
                res.data.district = res.data.district.toLowerCase().replace(new RegExp(key, 'g'), value).trim()
                res.data.sub_district = res.data.sub_district.toLowerCase().replace(new RegExp(key, 'g'), value).trim()
                payloadPickUpOrigin.district = res.data.district
                payloadPickUpOrigin.subDistrict = res.data.sub_district
            }
            await routeAlgo.getAllBySearch(`${payloadPickUpOrigin.subDistrict}, ${payloadPickUpOrigin.district}`).then(resRoute => {
                if (resRoute.data.length > 0) {
                    // choose first index because based on the search result on the top
                    payloadPickUpOrigin.district = resRoute.data[0].city
                    payloadPickUpOrigin.subDistrict = resRoute.data[0].route
                    payloadPickUpOrigin.routeId = resRoute.data[0].route_id
                    payloadPickUpOrigin.isCodOrigin = resRoute.data[0].is_cod_origin
                    payloadPickUpOrigin.isCodDestination = resRoute.data[0].is_cod_destination
                    localStorage.setItem('pickupRouteId', resRoute.data[0].route_id);
                }
                commit('SET_PICKUP_ORIGIN', payloadPickUpOrigin)
                dispatch('setSenderForm', {...state.senderForm, origin: payloadPickUpOrigin.subDistrict})
                dispatch('setSender', {
                    ...state.sender,
                    origin: payloadPickUpOrigin.subDistrict,
                    routeId: payloadPickUpOrigin.routeId
                })
            })
            return payloadPickUpOrigin;
        })
    },
    // call this to get the origin of the sameday
    async setSamedayPickUpOrigin({commit, dispatch, state}, payload) {
        return await routeAlgo.getReverseRoute(payload.lat, payload.lng).then(async res => {
            const payloadPickUpOrigin = {
                district: res.data.district,
                subDistrict: res.data.sub_district,
                routeId: 0,
            }
            for (const filter of filtersPickUpOrigin) {
                let [key, value] = filter.split('=')
                res.data.district = res.data.district.toLowerCase().replace(new RegExp(key, 'g'), value).trim()
                res.data.sub_district = res.data.sub_district.toLowerCase().replace(new RegExp(key, 'g'), value).trim()
                payloadPickUpOrigin.district = res.data.district
                payloadPickUpOrigin.subDistrict = res.data.sub_district
            }
            await routeAlgo.getAllBySearch(`${payloadPickUpOrigin.subDistrict}, ${payloadPickUpOrigin.district}`).then(resRoute => {
                if (resRoute.data.length > 0) {
                    // choose first index because based on the search result on the top
                    payloadPickUpOrigin.district = resRoute.data[0].city
                    payloadPickUpOrigin.subDistrict = resRoute.data[0].route
                    payloadPickUpOrigin.routeId = resRoute.data[0].route_id
                }
                commit('SET_SAMEDAY_PICKUP_ORIGIN', payloadPickUpOrigin)
                dispatch('setSamedayForm', {...state.samedayForm, origin: payloadPickUpOrigin.subDistrict, routeId: payloadPickUpOrigin.routeId})
                dispatch('setSameday', {...state.sameday, origin: payloadPickUpOrigin.subDistrict, routeId: payloadPickUpOrigin.routeId})
            })
        })
    },
    setRecipient({commit}, payload) {
        commit('SET_RECIPIENT', payload)
    },
    async setCheckPrice({commit, state}) {
        // if (state.recipient.destination === undefined || state.recipient.destination.length === 0
        //     || (state.package.weight > 1 && (state.package.length === 0 || state.package.width === 0 || state.package.height === 0)) || state.package.commodity.length === 0) {
        //     return
        // }
        if (state.recipient.destination === undefined || state.recipient.destination.length === 0 || state.package.commodity.length === 0) {
            return
        }

        commit('SET_LOADING_CHECK_PRICE_PAGE', true)
        commit('SET_ERROR_CHECK_PRICE', null)
        /**
         * @type {RequestCheckPriceAlgo}
         */
        const req = {
            "check_tariff_page": false,
            "cod_value": state.package.cod ? state.package.value : 0,
            "commodity": state.package.commodity.length > 0 ? state.package.commodity[0].valueData : '',
            "destination": state.recipient.destination.length > 0 ? state.recipient.destination[0].value : '',
            "goods_value": state.package.value,
            "height": state.package.height,
            "is_insurance": state.package.insurance,
            "length": state.package.length,
            "origin": state.typeOder == 'DROPOFF'
                ? localStorage.getItem('dropoffOrigin') || state.senderForm.dropoffOrigin
                : localStorage.getItem('origin') || state.senderForm.origin,
            "page_type": !state.package.dfod && !state.package.cod ? state.typeOder.toLowerCase() : "cod",
            "shipment_type": state.typeOder,
            "weight": parseFloat(state.package.weight),
            "width": state.package.width,
            "is_wood_package": state.package.fragile,
            "is_wood_packing": FlagsWoodPacking.permission_wood_packing_enable.isEnabled() && state.package.isWoodPacking,
            "is_dfod": state.package.dfod,
            "is_new_cod": state.package.dfod || state.package.cod ? true : false,
        }
        await checkShippingPriceAlgo.requestShippingPrice(req).then(res => {
            if (res.err) {
                let errMsg = res.err
                if (errMsg.includes('Data tidak ditemukan')) errMsg = "Kota tujuanmu mengalami masalah operasional sementara. Silahkan pilih kota lainnya."
                commit('SET_ERROR_CHECK_PRICE', errMsg)
            }
            commit('SET_RESPONSE_CHECK_PRICE', res.data || [])
        }).catch(err => {
            commit('SET_ERROR_CHECK_PRICE', err)
            commit('SET_RESPONSE_CHECK_PRICE', [])
        }).finally(() => commit('SET_LOADING_CHECK_PRICE_PAGE', false))
    },

    setBulkyCheckPrice({commit}) {
        /**
         * @type {RequestCheckPriceBulkyAlgo[]}
         */
        const reqs = []
        commit('SET_LOADING_CHECK_PRICE', true)
        commit('SET_LIST_ERROR_BULKY_CHECK_PRICE', [])
        state.recipientsPackage.forEach((recipient, index) => {
            /** @type {Recipient} */
            const dataRecipient = recipient
            if (dataRecipient.destination.length !== 0 && dataRecipient.choicePackage !== undefined) {
                /** @type {RequestCheckPriceBulkyAlgo} */
                const req = {
                    "check_tariff_page": false,
                    "cod_value": dataRecipient.isPackageCOD ? dataRecipient.packageValue : 0,
                    "commodity": dataRecipient.packageCommodity.length > 0 ? dataRecipient.packageCommodity[0].valueData : '',
                    "goods_value": dataRecipient.packageValue,
                    "is_insurance": dataRecipient.isPackageInsurance || false,
                    "height": dataRecipient.packageHeight || 0,
                    "id": index + 1,
                    "is_dfod": dataRecipient.isPackageDFOD,
                    "is_new_cod": dataRecipient.isPackageCOD || dataRecipient.isPackageDFOD,
                    "length": dataRecipient.packageLength,
                    "destination": dataRecipient.destination[0].value,
                    "origin": state.typeOder == 'DROPOFF' ? state.senderForm?.dropoffOrigin : `${state.senderForm.origin}`,
                    "page_type": !dataRecipient.isPackageCOD && !dataRecipient.isPackageDFOD ? "reguler" : "cod",
                    "product_type": dataRecipient.choicePackage.product_type?.toUpperCase(),
                    "shipment_type": state.typeOder,
                    "weight": dataRecipient.packageWeight,
                    "width": dataRecipient.packageWidth,
                    "is_wood_package": dataRecipient.isPackageFreagile
                }
                reqs.push(req)
            }
        })
        const dataRequest = {
            data: reqs,
            is_new_cod: true
        }
        commit('SET_ERROR_BULKY_CHECK_PRICE', null)
        checkShippingPriceAlgo.bulkyCheckShippingPrice(dataRequest).then(res => {
            if (res.err) {
                commit('SET_ERROR_BULKY_CHECK_PRICE', res.err)
            }

            const listBulkyError = []
            const allRecipient = [...state.recipientsPackage]
            res.data.forEach((dataResp) => {
                const currenIndex = allRecipient.findIndex((recipient) => {
                    return recipient.index === dataResp.id
                })
                if (currenIndex !== -1 && !('error' in dataResp)) {
                    allRecipient[currenIndex].choicePackage.price = dataResp.result.price
                    allRecipient[currenIndex].choicePackage.priceBase = dataResp.result.price_base
                    allRecipient[currenIndex].choicePackage.commoditySurchargeRate = dataResp.result.commodity_surcharge_rate
                    allRecipient[currenIndex].choicePackage.heavyWeightSurchargeRate = dataResp.result.heavy_weight_surcharge_rate
                    allRecipient[currenIndex].choicePackage.totalEstimatedPrice = dataResp.result.total_estimated_price
                    allRecipient[currenIndex].codFee = dataResp.result.cod_fee
                    allRecipient[currenIndex].insuranceFee = dataResp.result.insurance_rate
                }

                if (currenIndex !== -1 && ('error' in dataResp)) {
                    allRecipient[currenIndex].choicePackage.price = 0
                    allRecipient[currenIndex].choicePackage.priceBase = 0
                    allRecipient[currenIndex].choicePackage.commoditySurchargeRate = 0
                    allRecipient[currenIndex].choicePackage.heavyWeightSurchargeRate = 0
                    allRecipient[currenIndex].choicePackage.totalEstimatedPrice = 0
                    listBulkyError.push(`Pengiriman ${allRecipient[currenIndex].name} ${dataResp.error.message.id}`)
                }
            })

            //set error if service = pickup and product_type = jumbopack & interpack
            let containJumbopack = false;
            let containInterpack = false;
            if (allRecipient) containJumbopack = allRecipient.some(v => v.choicePackage.product_type.toLowerCase() === 'jumbopack')
            if (allRecipient) containInterpack = allRecipient.some(v => v.choicePackage.product_type.toLowerCase() === 'interpack')
            if (state.senderForm.service.toLowerCase() === 'pickup' && containJumbopack) listBulkyError.push(`Pengiriman pickup tidak mendukung product jumbopack`)
            if (state.senderForm.service.toLowerCase() === 'pickup' && containInterpack) listBulkyError.push(`Pengiriman pickup tidak mendukung product interpack`)
            
            commit('SET_RECIPIENT_PACKAGE', allRecipient)
            commit('SET_LIST_ERROR_BULKY_CHECK_PRICE', listBulkyError)

        }).catch(err => {
            commit('SET_ERROR_BULKY_CHECK_PRICE', err)
        }).finally(() => commit('SET_LOADING_CHECK_PRICE', false))
    },
    setBulkyCheckPriceNew({ commit, state, getters }) {
        return new Promise((resolve, reject) => {
            const reqs = [];
            commit('SET_LOADING_CHECK_PRICE', true);
            commit('SET_LIST_ERROR_BULKY_CHECK_PRICE', []);

            const senderForm = JSON.parse(localStorage.getItem('senderForm'));

            state.recipientsPackage.forEach((recipient, index) => {
                const dataRecipient = recipient;
                if (dataRecipient.choicePackage !== undefined) {
                    const phoneCode = dataRecipient.phoneCode || '';
                    const dropshipperPhoneCode = dataRecipient.dropshipperPhoneCode || '';

                    reqs.push({
                    recipient: {
                        recipient_name: dataRecipient.name,
                        phone_number: dataRecipient.phoneNumber ? phoneCode + dataRecipient.phoneNumber : '',
                        country_code: phoneCode.replace('+', ''),
                        address: dataRecipient.address,
                        quantity: dataRecipient.packageQuantity[0].value,
                    },
                    dropshipper: {
                        name: dataRecipient.dropshipperName,
                        phone_number: dataRecipient.dropshipperPhoneNumber ? dropshipperPhoneCode + dataRecipient.dropshipperPhoneNumber : '',
                        country_code: dataRecipient.dropshipperPhoneNumber ? dropshipperPhoneCode.replace('+', '') : '',
                    },
                    check_tariff_page: false,
                    cod_value: dataRecipient.isPackageCOD ? dataRecipient.packageValue : 0,
                    commodity: dataRecipient.packageCommodity.length > 0 ? dataRecipient.packageCommodity[0].valueData : '',
                    goods_value: dataRecipient.packageValue,
                    is_insurance: dataRecipient.isPackageInsurance || false,
                    height: dataRecipient.packageHeight || 0,
                    id: index + 1,
                    is_dfod: dataRecipient.isPackageDFOD,
                    is_new_cod: dataRecipient.isPackageCOD || dataRecipient.isPackageDFOD,
                    length: dataRecipient.packageLength,
                    destination: dataRecipient.destination[0]?.value,
                    origin:
                        state.typeOder == 'DROPOFF'
                        ? state.senderForm.dropoffOrigin ?? senderForm.dropoffOrigin ??''
                        : `${state.senderForm.origin}` ?? senderForm.origin ?? '',
                    page_type:
                        !dataRecipient.isPackageCOD && !dataRecipient.isPackageDFOD
                        ? 'reguler'
                        : 'cod',
                    product_type: dataRecipient.choicePackage.product_type?.toUpperCase(),
                    shipment_type: state.typeOder,
                    weight: dataRecipient.packageWeight,
                    width: dataRecipient.packageWidth,
                    is_wood_package: dataRecipient.isPackageFreagile,
                    is_wood_packing: FlagsWoodPacking.permission_wood_packing_enable.isEnabled() && dataRecipient.isPackageWoodPacking
                    });
                }
            });

            const dataRequest = {
                data: reqs,
                is_new_cod: true
            };

            commit('SET_ERROR_BULKY_CHECK_PRICE', null);

            // Rows carry their own CIPL flags (snapshotted when the document was saved).
            // Drafts saved before that field existed still need a fetch — resolve those per
            // unique destination code, then commit the result back onto the row so it only
            // ever happens once per draft. CIPL only applies when shipment seamless is active.
            const flagsByCode = {};
            const isSeamless = getters.IS_SHIPMENT_SEAMLESS;
            const legacyCodes = isSeamless ? [...new Set(
                state.recipientsPackage
                    .filter(r => r.choicePackage?.product_type?.toUpperCase() === 'INTERPACK' && !r.ciplFlags)
                    .map(r => r.destination?.[0]?.code)
                    .filter(Boolean)
            )] : [];
            const resolveCiplFlags = legacyCodes.map(async (code) => {
                let flags = null;
                try {
                    const { data, err } = await internationalDocumentUseCase.getDetail(code);
                    flags = (err || !data) ? null : internationalDocumentUseCase.mapFlags(data);
                } catch (e) {
                    flags = null; // unknown → isCiplRequired treats as required (block doc-less rows)
                }
                return { code, flags };
            });

            return Promise.all(resolveCiplFlags)
            .then((results) => {
                results.forEach(({ code, flags }) => {
                    flagsByCode[code] = flags;
                    if (!flags) return;
                    state.recipientsPackage.forEach(r => {
                        if (!r.ciplFlags && r.destination?.[0]?.code === code) r.ciplFlags = flags;
                    });
                });
                return checkShippingPrice.bulkyCheckShippingPrice(dataRequest);
            })
            .then(res => {
                const listBulkyError = [];
                let allRecipient = [...state.recipientsPackage];
                
                // update here: scrub wood packing from the draft when the flag is off
                if (!FlagsWoodPacking.permission_wood_packing_enable.isEnabled()) {
                    allRecipient = allRecipient.map(r =>
                        r.isPackageWoodPacking ? { ...r, isPackageWoodPacking: false } : r
                    );
                }

                if (res.data.length > 0) {
                    res.data.forEach(dataResp => {
                        const currenIndex = allRecipient.findIndex(
                            recipient => recipient.index === dataResp.id
                        );

                        if (currenIndex !== -1 && !('error' in dataResp)) {
                            if (
                                allRecipient[currenIndex].choicePackage.product_type?.toUpperCase() === 'INTERPACK' &&
                                !allRecipient[currenIndex].postalCode.length
                            ) {
                                allRecipient[currenIndex].choicePackage.price = dataResp.result.price;
                                allRecipient[currenIndex].choicePackage.priceBase = dataResp.result.price_base;
                                allRecipient[currenIndex].choicePackage.commoditySurchargeRate = dataResp.result.commodity_surcharge_rate;
                                allRecipient[currenIndex].choicePackage.heavyWeightSurchargeRate = dataResp.result.heavy_weight_surcharge_rate;
                                allRecipient[currenIndex].choicePackage.totalEstimatedPrice = dataResp.result.total_estimated_price;
                                allRecipient[currenIndex].choicePackage.woodPackingRate = dataResp.result.wood_packing_rate || 0;
                                allRecipient[currenIndex].codFee = dataResp.result.cod_fee;
                                allRecipient[currenIndex].insuranceFee = dataResp.result.insurance_rate;
                                allRecipient[currenIndex].status = 'tidak sesuai';
                                allRecipient[currenIndex].errorField = 'postal_code';
                                allRecipient[currenIndex].errorText = 'Kode pos wajib diisi';
                                listBulkyError.push(`Pengiriman ${allRecipient[currenIndex].name} Kode pos wajib diisi`);
                            }
                            else if (
                                isSeamless &&
                                allRecipient[currenIndex].choicePackage.product_type?.toUpperCase() === 'INTERPACK' &&
                                allRecipient[currenIndex].postalCode[0].value &&
                                internationalDocumentUseCase.isCiplRequired(
                                    // Row snapshot first; flagsByCode only covers drafts saved
                                    // before ciplFlags existed (fetched below, then committed here).
                                    allRecipient[currenIndex].ciplFlags
                                    ?? flagsByCode[allRecipient[currenIndex].destination?.[0]?.code]
                                ) &&
                                !allRecipient[currenIndex].interPackDocument
                            ) {
                                // interpack destination requires CIPL (some flag true) but doc is missing
                                allRecipient[currenIndex].choicePackage.price = dataResp.result.price;
                                allRecipient[currenIndex].choicePackage.priceBase = dataResp.result.price_base;
                                allRecipient[currenIndex].choicePackage.commoditySurchargeRate = dataResp.result.commodity_surcharge_rate;
                                allRecipient[currenIndex].choicePackage.heavyWeightSurchargeRate = dataResp.result.heavy_weight_surcharge_rate;
                                allRecipient[currenIndex].choicePackage.totalEstimatedPrice = dataResp.result.total_estimated_price;
                                allRecipient[currenIndex].choicePackage.woodPackingRate = dataResp.result.wood_packing_rate || 0;
                                allRecipient[currenIndex].codFee = dataResp.result.cod_fee;
                                allRecipient[currenIndex].insuranceFee = dataResp.result.insurance_rate;
                                allRecipient[currenIndex].status = 'tidak sesuai';
                                allRecipient[currenIndex].errorField = 'cipl';
                                allRecipient[currenIndex].errorText = 'Dokumen Internasional (CIPL) wajib diisi';
                                listBulkyError.push(`Pengiriman ${allRecipient[currenIndex].name} Dokumen Internasional (CIPL) wajib diisi`);
                            }
                            else {
                                allRecipient[currenIndex].choicePackage.price = dataResp.result.price;
                                allRecipient[currenIndex].choicePackage.priceBase = dataResp.result.price_base;
                                allRecipient[currenIndex].choicePackage.commoditySurchargeRate = dataResp.result.commodity_surcharge_rate;
                                allRecipient[currenIndex].choicePackage.heavyWeightSurchargeRate = dataResp.result.heavy_weight_surcharge_rate;
                                allRecipient[currenIndex].choicePackage.totalEstimatedPrice = dataResp.result.total_estimated_price;
                                allRecipient[currenIndex].choicePackage.woodPackingRate = dataResp.result.wood_packing_rate || 0;
                                allRecipient[currenIndex].codFee = dataResp.result.cod_fee;
                                allRecipient[currenIndex].insuranceFee = dataResp.result.insurance_rate;
                                allRecipient[currenIndex].status = 'sesuai';
                                allRecipient[currenIndex].errorField = '';
                                allRecipient[currenIndex].errorText = '';
                            }
                        }

                        if (currenIndex !== -1 && 'error' in dataResp) {
                            allRecipient[currenIndex].choicePackage.price = 0;
                            allRecipient[currenIndex].choicePackage.priceBase = 0;
                            allRecipient[currenIndex].choicePackage.commoditySurchargeRate = 0;
                            allRecipient[currenIndex].choicePackage.heavyWeightSurchargeRate = 0;
                            allRecipient[currenIndex].choicePackage.totalEstimatedPrice = 0;
                            allRecipient[currenIndex].status = 'tidak sesuai';
                            allRecipient[currenIndex].errorField = dataResp.error.field;
                            allRecipient[currenIndex].errorText = dataResp.error.message.id;
                            listBulkyError.push(`Pengiriman ${allRecipient[currenIndex].name} ${dataResp.error.message.id}`);
                        }
                    });
                }
                else {
                    allRecipient.forEach(r => {
                        r.status = "tidak sesuai";
                        if (r.choicePackage) {
                            r.choicePackage.price = 0;
                            r.choicePackage.priceBase = 0;
                            r.choicePackage.commoditySurchargeRate = 0;
                            r.choicePackage.heavyWeightSurchargeRate = 0;
                            r.choicePackage.totalEstimatedPrice = 0;
                        }
                    });

                    listBulkyError.push("Gagal mendapatkan harga untuk semua penerima");
                }

                commit('SET_RECIPIENT_PACKAGE', allRecipient);
                commit('SET_LIST_ERROR_BULKY_CHECK_PRICE', listBulkyError);

                resolve();
            })
            .catch(err => {
                commit('SET_ERROR_BULKY_CHECK_PRICE', err);
                reject(err);
            })
            .finally(() => {
                commit('SET_LOADING_CHECK_PRICE', false);
            });
        });
    },
    setRecipientPackage({commit}, payload) {
        commit('SET_RECIPIENT_PACKAGE', payload)
    },
    setIsLoadingSamedayPrice({commit}, payload) {
        commit('SET_IS_LOADING_SAMEDAY_PRICE', payload)
    },
    setSamedayCheckPriceData({commit}, payload) {
        commit('SET_SAMEDAY_CHECK_PRICE_DATA', payload)
    },
    getSameDayBulkyCheckPrice({dispatch, commit, state}) {
       dispatch('setSamedayCheckPriceData', {})
       if (state.isLoadingSamedayPrice) return


       const origin = state.samedayForm.origin
       const isInsurance = state.samedayForm.isInsurance

       if (origin && state.samedayForm.itemQuantity.length) {
        dispatch('setIsLoadingSamedayPrice', true)
        const totalPackages = state.samedayForm.itemQuantity[0].value
        const checkPricePayloads = [...Array(totalPackages)].map((_package, index) => {
                return {
                    id: index + 1,
                    height: 10,
                    width: 10,
                    length: 10,
                    weight: 1,
                    origin: origin,
                    page_type: 'sameday',
                    product_type: 'SAMEDAY',
                    shipment_type: 'PICKUP',
                    goods_value: 1000000,
                    is_insurance: isInsurance
                }
        })

        const payloadRequest = {
            data: checkPricePayloads
        }

        checkShippingPriceAlgo.bulkyCheckShippingPrice(payloadRequest).then((res) => {
            dispatch('setSamedayCheckPriceData', res)
        }).catch((err) => {
                commit('SET_ERROR_BULKY_CHECK_PRICE', err)
        }).finally(() => {
            dispatch('setIsLoadingSamedayPrice', false)
        })
        }
    },
    setSamedayFormValidation({commit}, payload) {
        commit('SET_SAMEDAY_FORM_VALIDATION', payload)
    }
}

const mutations = {
    'SET_IS_PICKUP_ERROR' (state, payload) {
        state.isPickupError = payload;
    },
    'RESET_ORDER_STATE'(state) {
        Object.assign(state, createInitialState())
    },
    'SET_PICKUP_BOOST_VALUE'(state, payload) {
        state.pickupBoostValue = payload;
    },
    'SET_IS_PICKUP_BOOST' (state, payload) {
        state.isPickupBoost = payload;
    },
    'SET_TYPE_ORDER'(state, payload) {
        state.typeOder = payload
    },
    'SET_SAMEDAY_TYPE_ORDER'(state, payload) {
        state.samedayTypeOder = payload
    },
    'SET_SENDER'(state, payload) {
        state.sender = payload
    },
    'SET_SAMEDAY'(state, payload) {
        state.sameday = payload
    },
    'SET_SENDER_FORM'(state, payload) {
        state.senderForm = payload
    },
    'SET_SAMEDAY_FORM'(state, payload) {
        state.samedayForm = payload
    },
    'SET_PICKUP_ORIGIN'(state, payload) {
        state.pickUpOrigin = payload
    },
    'SET_SAMEDAY_PICKUP_ORIGIN'(state, payload) {
        state.pickUpOrigin = payload
    },
    'SET_PICKUP_SCHEDULE'(state, payload) {
        state.pickUpSchedules = payload
    },
    'SET_RECIPIENT'(state, payload) {
        localStorage.setItem(ORDER_LOCAL_STORAGE_KEY.RECIPIENT, JSON.stringify(payload))
        state.recipient = payload
    },
    'SET_ERROR_RECIPIENT'(state, payload) {
        state.validateRecipient[payload.key] = payload['value']
    },
    'SET_VALIDATE_DROP_SHIPPER'(state, payload) {
        state.validateDropShipper[payload.key] = payload['value']
    },
    'SET_PACKAGE'(state, payload) {
        state.package = payload
        localStorage.setItem(ORDER_LOCAL_STORAGE_KEY.PACKAGE, JSON.stringify(payload))
    },
        'ADD_EMPTY_RECIPIENT_PACKAGE'(state) {
        state.recipientsPackage.push({
            isPackageCOD: false,
            isValidDropshipper: false,
            dropshipperName: "",
            dropshipperPhoneNumber: "",
            index: state.recipientsPackage.length + 1,
            name: "",
            phoneNumber: "",
            phoneCodeId: "",
            address: "",
            addressLabel: "rumah",
            destination: [],
            referencePoint: "",
            labelPoint: "",
            packageCommodity: "",
            isPackageFreagile: false,
            isPackageWoodPacking: false,
            packageQuantity: 1,
            packageWeight: 1,
            packageWidth: 0,
            packageLength: 0,
            packageHeight: 0,
            packageValue: 0,
            isPackageInsurance: false,
            isPackageDFOD: false
        })


        localStorage.removeItem(ORDER_LOCAL_STORAGE_KEY.RECIPIENT)
        localStorage.removeItem(ORDER_LOCAL_STORAGE_KEY.PACKAGE)

    },
    /**
     *
     * @param state
     * @param payload {Recipient[]}
     */
    'SET_RECIPIENT_PACKAGE'(state, payload) {
        if (payload.length >= 1) {
            // Move heavy CIPL photos into IndexedDB so rows stay slim in localStorage
            slimRecipientPackage(payload)
            localStorage.setItem(ORDER_LOCAL_STORAGE_KEY.RECIPIENT_PACKAGE, JSON.stringify(payload))
        }
        state.recipientsPackage = payload
    },
    'SET_SELECTED_PRODUCT'(state, payload) {
        const recipient = state.recipientsPackage.find(r => r.index === payload.index);
        if (recipient) {
            recipient.choicePackage = {
                product_type: payload.product.product_type,
                price: payload.product.price,
                priceBase: payload.product.price_base,
                commoditySurchargeRate: payload.product.commodity_surcharge_rate,
                heavyWeightSurchargeRate: payload.product.heavy_weight_surcharge_rate,
                totalEstimatedPrice: payload.product.total_estimated_price,
                estimated: payload.product.estimated
            };
        }
    },
    'UPDATE_BULK_RECIPIENT_PACKAGE'(state, payload) {
        state.recipientPackage = payload;
    },
    'SET_RECIPIENT_STATUS'(state, { index, status }) {
        const recipient = state.recipientsPackage.find(r => r.index === index);
        if (recipient) {
            recipient.status = status;
        }
    },
    'CLEAN_RECIPIENT_PACKAGE'(state, currentPayload) {
        const currentState = currentPayload
        const newState = []
        // reset index recipient
        currentState.forEach((recipient) => {
            if (recipient.destination.length > 0 && recipient.choicePackage) {
                recipient.index = newState.length + 1
                newState.push(recipient)
            }
        })
        
        state.recipientsPackage = newState
        if (newState.length > 0) {
            slimRecipientPackage(state.recipientsPackage)
            localStorage.setItem(ORDER_LOCAL_STORAGE_KEY.RECIPIENT_PACKAGE, JSON.stringify(state.recipientsPackage))
        }
    },
    /**
     *
     * @param state
     * @param index {number}
     */
    'DELETE_RECIPIENT_PACKAGE'(state, index) {
        const dropped = state.recipientsPackage.find(val => val.index === index)
        dropRecipientFiles(dropped)
        state.recipientsPackage = state.recipientsPackage.filter(val => val.index !== index)
        // reset index
        state.recipientsPackage.forEach((val, index) => val.index = index + 1)
        slimRecipientPackage(state.recipientsPackage)
        localStorage.setItem(ORDER_LOCAL_STORAGE_KEY.RECIPIENT_PACKAGE, JSON.stringify(state.recipientsPackage))
    },
    'SET_LOADING_CHECK_PRICE'(state, payload) {
        state.isLoadingCheckPrice = payload
    },
    'SET_LOADING_CHECK_PRICE_PAGE'(state, payload) {
        state.isLoadingCheckPricePage = payload
    },
    'SET_RESPONSE_CHECK_PRICE'(state, payload) {
        state.isLoadingCheckPrice = false
        state.responseCheckPrice = payload
    },
    'SET_IGNORE_CHANGES_FOR_CHECKPRICE'(state, value) {
        state.ignoreChangesForCheckPrice = value;
    },
    'SET_ADD_NEW_RECIPIENT'(state, isNew) {
        if (isNew) {
            state.recipient = {
                name: "",
                phoneNumber: "",
                phoneCode: "+62",
                benchmark: "",
                address: "",
                addressLabel: "rumah",
                destination: [],
            }
            state.package = {
                commodity: [],
                quantity: [{
                    label: '1',
                    value: 1,
                }],
                weight: 1,
                length: 0,
                width: 0,
                height: 0,
                value: 0,
                insurance: false,
                fragile: false,
                isWoodPacking: false,
                cod: false,
                dfod: false,
                productType: "",
            }
        }
        state.isAddNewRecipient = isNew
    },
    SET_RECIPIENT_CHOOSE_PRODUCT(state, payload) {
        state.recipientChooseProduct = payload
    },
    SET_ERROR_CHECK_PRICE(state, payload) {
        state.errorCheckPrice = payload
    },
    SET_ERROR_BULKY_CHECK_PRICE(state, payload) {
        state.errorBulkyCheckPrice = payload
    },
    SET_EDIT_RECIPIENT_PACKAGE_INDEX(state, payload) {
        localStorage.setItem(ORDER_LOCAL_STORAGE_KEY.EDIT_INDEX, JSON.stringify(payload))
        state.editIndex = payload
    },
    SET_LIST_ERROR_BULKY_CHECK_PRICE(state, payload) {
        state.listOfErrorsBulkyCheckPrice = payload;
    },
    SET_LIST_RECEIVER_PRODUCT(state, payload) {
        state.listReceiverProduct = payload
    },
    SET_TRIGGER_ADD_NEW_RECIPIENT(state, payload) {
        state.triggerAddNewRecipient = payload
    },
    SET_DROPSHIPPER(state, payload) {
        state.getDropShipper = payload || {
            name: "",
            phoneNumber: "",
            phoneCode: "+62",
            phoneCodeId: 17,
            isActive: false
        };
    },
    SET_CIPL(state, payload) {
        state.getCIPL = payload || {
            email: "",
            id: "",
            taxId: "",
            file: [],
            fileKey: null,
        };
    },
    SET_CIPL_FLAGS(state, flags) {
        state.ciplFlags = flags;
    },
    RESET_CIPL_FLAGS(state) {
        state.ciplFlags = null;
    },
    SET_IS_LOADING_SAMEDAY_PRICE(state, payload) {
        state.isLoadingSamedayPrice = payload
    },
    SET_SAMEDAY_CHECK_PRICE_DATA(state, payload) {
        state.samedayCheckPriceData = payload
    },
    SET_SAMEDAY_FORM_VALIDATION(state, payload) {
        state.samedayFormValidation = payload
    }
}

const getters = {
    IS_SHIPMENT_SEAMLESS: () => {
      return FlagsShipmentSeamless.shipment_seamless_enable.isEnabled()
    },
    IS_PICKUP_ERROR: (state) => {
        return state.isPickupError;
    },
    GET_PICKUP_BOOST_VALUE: (state) => {
        return state.pickupBoostValue;
    },
    IS_PICKUP_BOOST: (state) => {
        return state.isPickupBoost;
    },
    TYPE_ORDER: state => {
        return state.typeOder
    },
    SAMEDAY_TYPE_ORDER: state => {
        return state.samedayTypeOder
    },
    SENDER: state => {
        return state.sender
    },
    SAMEDAY: state => {
        return state.sameday
    },
    SENDER_FORM: state => {
        return state.senderForm
    },
    SAMEDAY_FORM: state => {
        return state.samedayForm
    },
    GET_RECIPIENT: state => {
        return state.recipient
    },
    GET_PACKAGE: state => {
        return state.package
    },
    GET_RECIPIENT_PACKAGE: state => {
        return state.recipientsPackage
    },
    GET_RECIPIENT_PACKAGE_HAS_PRODUCT: state => {
        return state.recipientsPackage.filter((item) => item.destination.length > 0 && item.choicePackage);
    },
    GET_RECIPIENT_PACKAGE_HAS_PRODUCT_COD: state => {
        return state.recipientsPackage.filter((item) => {
            return item.destination.length > 0 && item.choicePackage && (item.isPackageCOD || item.isPackageDFOD)
        });
    },
    GET_LOADING_PRICE_PRODUCT: state => {
        return state.isLoadingCheckPrice
    },
    GET_LOADING_PRICE_PRODUCT_PAGE: state => {
        return state.isLoadingCheckPricePage
    },
    GET_PICKUP_ORIGIN: state => {
        return state.pickUpOrigin
    },
    GET_SAMEDAY_PICKUP_ORIGIN: state => {
        return state.samedayPickUpOrigin
    },
    GET_PICKUP_SCHEDULE: state => {
        return state.pickUpSchedules
    },
    GET_RESPONSE_CHECK_PRICE: state => {
        return state.responseCheckPrice
    },
    GET_ADD_NEW_RECIPIENT: state => {
        return state.isAddNewRecipient
    },
    GET_VALIDATE_RECIPIENT: state => {
        return state.validateRecipient
    },
    GET_RECIPIENT_CHOOSE_PRODUCT: state => {
        return state.recipientChooseProduct
    },
    GET_CURRENT_RECIPIENT_DATA_VALID: (state) => {
        const isFilledRecipient = state.recipient.name.trim().length > 0 && state.recipient.phoneNumber !== '' && state.recipient.address.trim().length > 0
        const isValidRecipient = Object.values(state.validateRecipient).every((val) => !val) && isFilledRecipient
        const isValidMainRecipient = isValidRecipient && state.recipient.destination.length > 0
        const isValidCommodity = state.package.commodity.length > 0
        const isValidWeight = FlagsMinipack.minipack_enable.isEnabled() === true ? parseFloat(state.package.weight) > 0 : parseFloat(state.package.weight) === 1 || (parseFloat(state.package.weight) > 1 && parseFloat(state.package.width) > 0 && parseFloat(state.package.length) > 0 && parseFloat(state.package.height) > 0)
        const isValidValue = ((state.package.value > 0 && state.package.insurance) || !state.package.insurance)
        const isValidPackage = isValidCommodity && isValidWeight && isValidValue
        const isValidDropShipper = state.validateDropShipper.isSelected ? state.validateDropShipper.isValid : true
        const isValidGoodsValue = state.errorCheckPrice === null || state.errorCheckPrice === ''
        const hasNoSameAddress = !state.recipientsPackage.some((pkg) =>
            isSameSenderRecipientAddress(state.sender?.address, pkg.address)
        )
        return isValidMainRecipient && isValidPackage && isValidDropShipper && isValidGoodsValue && hasNoSameAddress
    },
    GET_ERROR_CHECK_PRICE: state => {
        return state.errorCheckPrice
    },
    GET_ERROR_BULKY_CHECK_PRICE: state => {
        return state.errorBulkyCheckPrice
    },
    GET_EMPTY_RECIPIENT: state => {
        return state.recipientsPackage.length === 0 || localStorage.getItem('recipientPackage').length === 0
    },
    GET_EMPTY_RECIPIENT_PACKAGE: state => {
        return state.recipient.name === '' && state.recipient.phoneNumber === '' && state.recipient.address.trim().length === 0
    },
    GET_EDIT_RECIPIENT_PACKAGE_INDEX: state => {
        return state.editIndex
    },
    GET_CURRENT_SENDER_FORM_DATA_VALID: (state) => {
        const checkEmail = state.senderForm.email ? /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(state.senderForm.email) : true;
        const isFilledSender = state.senderForm.name.trim().length > 2 && (state.senderForm.phoneNumber.length > 6 && state.senderForm.phoneNumber.length < 13 && checkEmail)
        if (state.senderForm.service == 'pickup') {
            const isValidLastCoordinate = JSON.stringify(state.senderForm.lastCoordinate) !== JSON.stringify({})
            return isFilledSender && isValidLastCoordinate
        } else {
            const isValidDropoffAddress = state.senderForm.dropoffAddress.length > 0 ? state.senderForm.dropoffAddress.length > 10 : true
            const isValidDropoff = state.senderForm.subdistrict.length !== 0 && isValidDropoffAddress
            return isFilledSender && isValidDropoff
        }
    },
    GET_CURRENT_SENDER_FORM_DATA_VALID_NEW: (state, getters) => {
        const checkEmail = state.senderForm.email ? /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(state.senderForm.email) : true;
        const isFilledSender = state.senderForm.name.trim().length > 2 && (state.senderForm.phoneNumber.length > 6 && state.senderForm.phoneNumber.length < 17 && checkEmail)
        const hasNoSameAddress = !getters.GET_RECIPIENT_PACKAGE.some(pkg =>
            isSameSenderRecipientAddress(state.sender?.address, pkg.address)
        )
        if (state.senderForm.service == 'pickup') {
            const isValidLastCoordinate = state.senderForm.lastCoordinate && JSON.stringify(state.senderForm.lastCoordinate) !== JSON.stringify({})
            return isFilledSender && isValidLastCoordinate && !getters.IS_PICKUP_ERROR && hasNoSameAddress
        } else {
            const isValidDropoffOrigin = state.senderForm.dropoffOrigin
            // const isValidSubdistrict = state.senderForm.subdistrict.length !== null && state.senderForm.subdistrict.length !== 0 && isValidDropoffOrigin
            return isFilledSender && !!isValidDropoffOrigin && hasNoSameAddress
        }
    },
    GET_LIST_ERROR_BULKY_CHECK_PRICE: (state) => {
        return state.listOfErrorsBulkyCheckPrice
    },
    GET_VALIDATE_DROPSHIPPER: state => {
        return state.validateDropShipper
    },
    GET_LIST_RECEIVER_PRODUCT: state => {
        return state.listReceiverProduct.map(item => item.value)
    },
    GET_TRIGGER_ADD_NEW_RECIPIENT: state => {
        return state.triggerAddNewRecipient
    },
    GET_DROPSHIPPER: state => {
        return state.getDropShipper;
    },
    GET_CIPL: state => {
        return state.getCIPL;
    },
    GET_CIPL_FLAGS: state => {
        return state.ciplFlags;
    },
    GET_IS_LOADING_SAMEDAY_PRICE: state => {
        return state.isLoadingSamedayPrice
    },
    GET_SAMEDAY_CHECK_PRICE_DATA: state => {
        return state.samedayCheckPriceData
    },
    GET_SAMEDAY_FORM_VALIDATION: state => {
        return state.samedayFormValidation
    },
    GET_SAMEDAY_TOTAL_BILLING: state => {
        let price = 0;
        let priceBase = 0;
        let priceBaseDefault = 0;
        let singleInsuranceFee = 0;
        let pickupFee = 0;
        let pickupFeeDiscount = 0;
        let singlePriceBase = 0;
        let totalInsuranceFee = 0;
        let totalPricebase = 0;
        let totalPackages = 0;

        const {data, total, pickup_fee, pickup_fee_discount} = state.samedayCheckPriceData


        if (data) {
            totalPackages = state.samedayForm.itemQuantity[0].value
            pickupFee = pickup_fee
            pickupFeeDiscount = pickup_fee_discount
            price = total + pickupFee
            priceBase = (data[0].result.total_estimated_price * totalPackages) + pickupFee - pickupFeeDiscount
            singleInsuranceFee = data[0].result.insurance_rate
            singlePriceBase = data[0].result.price_base
            totalInsuranceFee = singleInsuranceFee * totalPackages
            totalPricebase = (singlePriceBase * totalPackages)
        }

        return {
            price,
            priceBase,
            priceBaseDefault,
            singleInsuranceFee,
            pickupFee,
            pickupFeeDiscount,
            singlePriceBase,
            totalInsuranceFee,
            totalPricebase,
            totalPackages
        }
        }
}

export default {
    state,
    actions,
    mutations,
    getters
}